// Obtener la IP/localhost

const CONFIG = {

  //BASE_URL: 'https://www.tresatec.com.ar/Demo/',  //demo Tresatec
  //API_URL: 'https://www.tresatec.com.ar/Demo/API',

  //BASE_URL: `http://${window.location.hostname}:3000/`,  // Dinámico
  //API_URL: `http://${window.location.hostname}/tresatecedutech/tresaedu-git/PLataforma-educativa--Tresatec-Demofinal/API`, // Dinámico

  //BASE_URL: `http://192.168.1.49:3000/`,  // Dinámico
  //API_URL: `http://192.168.1.49:3000/tresatecedutech/tresaedu-git/PLataforma-educativa--Tresatec-Demofinal/API`, // Dinámico

  //Petit CON https
  //BASE_URL: 'https://www.institutopetitdemeurville.com.ar/',  //Localhost
  //API_URL: 'https://www.institutopetitdemeurville.com.ar/API'

  //Americ CON http con host de windows
  //BASE_URL: 'http://www.institutoamerica.ar/',  //Localhost
  //API_URL: 'http://www.institutoamerica.ar/API'

  //Americ CON https
  BASE_URL: 'https://www.institutoamerica.ar/',  //Localhost
  API_URL: 'https://www.institutoamerica.ar/API'

};

export default CONFIG;

